var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notice" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          {
            staticClass: "back",
            on: {
              click: function () {
                _vm.$router.go(-1)
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("../../assets/notice/back.png") },
            }),
            _vm._v("返回 "),
          ]
        ),
        _c("div", { staticClass: "user" }),
      ]),
      _vm._m(0),
      _c("noticeDialog"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("div", { staticClass: "bg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }